import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { getPhaseGoalsForCurrentPhase } from '../../../redux/Game/selectors';
import PhaseGoal from './PhaseGoal';
import Title from '../../baseComponents/Title';
import { GameActions } from '../../../redux/Game';

const Container = styled.div`
  align-content: center;
  justify-content: center;
  margin-bottom: 32px;
`;

const PhaseGoals = () => {
  const dispatch = useDispatch();
  const goals = useSelector((state) => getPhaseGoalsForCurrentPhase(state));
  const {
    game: { controlledPlayer, players },
  } = useSelector((state) => state);

  let phaseGoals = [];
  const disabled = players.length > 1 && controlledPlayer !== 0;
  phaseGoals = goals.map((goal) => {
    return (
      <PhaseGoal
        key={goal.id}
        phaseGoal={goal}
        onChange={() => dispatch(GameActions.setPhaseGoalState(goal))}
        disabled={disabled}
      />
    );
  });

  return (
    <Container>
      <Title text="Phase Goals" />
      {phaseGoals}
    </Container>
  );
};

export default PhaseGoals;
